<!--  @if(editable) {
  <app-dynamic-form
    [fields]="fieldsEdit"
    [type]="'horizontal'"
    [editable]="true"
    [translation]="true"
    (action)="handleAction($event)"
    (changes)="detectFormState($event)"
  ></app-dynamic-form>
  }@else {
  <app-dynamic-form
    [fields]="fieldsView"
    [type]="'horizontal'"
    [editable]="editable"
    [translation]="true"
    (changes)="detectFormState($event)"
  ></app-dynamic-form>
  }  -->
 
   
 

 <p-card class="shadow-2">
  <ng-template pTemplate="header">
    <div class="flex justify-content-between align-items-center w-full">
      <div class="inline-flex align-items-center gap-2">
        <p-avatar image="https://ui-avatars.com/api/?name={{ user.firstname + '+' + user.lastname }}" shape="circle" />
        <span class="font-bold white-space-nowrap">{{ user.firstname + " " + user.lastname }}</span>
      </div>
      <p-button severity="secondary" [text]="true">
        <i class="pi pi-power-off"></i>
        <span class="pl-2 font-bold link-secondary" (click)="logout()">{{'buttons.logout' | translate}}</span>
      </p-button>
    </div>
  </ng-template>
      <app-user-detail [editable]="editable" [data]="user" (changed)="changeBtnStatus($event)"
       #userDetail (formValid)="formValid($event)"></app-user-detail>
  <ng-template pTemplate="footer">
    <p-button
      type="button"
      icon="pi pi-user-edit"
      [outlined]="true"
      (click)="editable = true"
      label="{{'buttons.edit' | translate}}"
      [hidden]="editable"></p-button>
    <p-button
      type="button"
      icon="pi pi-times-circle"
      [outlined]="true"
      (click)="editable = false"
      label="{{'buttons.cancel' | translate}}"
      [hidden]="!editable"
      severity="secondary"></p-button>
    <p-button
      type="button"
      icon="pi pi-check-square"
      [outlined]="formNotTouch"
      (click)="updateForm()"
      class="btn-update-form"
      label="{{'global.validateModifications' | translate}}"
      [hidden]="!editable"
      [disabled]="!buttonEnabled"></p-button>
  </ng-template>
 <!--  <app-dynamic-form
    [fields]="fieldsView"
    [type]="'horizontal'"
    [editable]="false"
    [translation]="true"></app-dynamic-form> -->
</p-card> 
<!-- <div class="absolute mt-3" style="left: 25%; right: 25%;">
  <p-message [(value)]="messages"  [closable]="false" />
</div> -->
<p-toast></p-toast>
